import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-physicians-card-dialog",
  templateUrl: "./physicians-card-dialog.component.html",
  styleUrls: ["./physicians-card-dialog.component.scss"],
})
export class PhysiciansCardDialogComponent implements OnInit {
  @Input() practiceData;
  constructor() {}

  ngOnInit() {}

  filterByRole(item, type) {
    return item ? item.filter((x) => x.roleCategory === type) : item;
  }
}
